import { useState, useContext, useEffect } from 'react'

import clsx from 'clsx'
import AppBar from '@aura/components/app-bar'
import Toolbar from '@aura/components/toolbar'
import { withStyles } from '@aura/components/styles'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import constants from '../../constants/languages'
import MenuContext from '../../utils/menu-context'
import appContext from '../../utils/app-context'
import { REGISTRATION_ROUTE, FORGOTPWD_ROUTE, LOGIN_ROUTE } from '../../constants/routes'
import LanguageButton from '../language-button'
import styles from './styles'


const Component = ({
    classes
}) => {
    const menuContext = useContext(MenuContext)
    const { mobileDevice } = menuContext
    const { application: applicationContext } = useContext(appContext)
    const { loginTitle } = applicationContext
    const { i18n, t: translate } = useTranslation()
    const [ currentRoute, setCurrentRoute ] = useState(LOGIN_ROUTE)

    document.title = translate(loginTitle)

    useEffect(() => {
        switch (true) {
            case window.location.pathname.includes(FORGOTPWD_ROUTE):
                setCurrentRoute(FORGOTPWD_ROUTE)
                break
            case window.location.pathname.includes(REGISTRATION_ROUTE):
                setCurrentRoute(REGISTRATION_ROUTE)
                break
            case window.location.pathname.includes(LOGIN_ROUTE):
                setCurrentRoute(LOGIN_ROUTE)
                break
            default:
                setCurrentRoute(LOGIN_ROUTE)
                break
        }
    }, [])

    return (<div className={classes.root}>
        <AppBar className={clsx(classes.appBar, {
            [classes.appBarShift]: !mobileDevice
        })} position="relative" color="inherit">
            <Toolbar className={clsx(classes.toolbar, mobileDevice && classes.toolbarMobile)}>
                <div className={clsx(classes.logoContainer, { [classes.titleShift]: !mobileDevice })}>
                    {
                        (i18n.language === constants.ENGLISH)
                            ? <a href="https://www.rbccm.com/en/" target="_blank" rel="noopener noreferrer" alt="rbccm logo">
                                <img className={classes.logoEn} src={'/img/RBC_Capital_Markets_logo_en.svg?url'} />
                            </a>
                            : <a href="https://www.rbccm.com/fr/" target="_blank" rel="noopener noreferrer" alt="rbccm logo">
                                <img className={classes.logoFr} src={'/img/RBC_Capital_Markets_logo_fr.svg?url'} />
                            </a>
                    }
                </div>
                <LanguageButton clsName='languageButton' component={currentRoute} loginTitle={loginTitle} variant='text'></LanguageButton>
            </Toolbar>
        </AppBar>
    </div>)
}
Component.propTypes = {
    classes: PropTypes.shape({
        appBar: PropTypes.object,
        appBarShift: PropTypes.object,
        button: PropTypes.object,
        fullHeight: PropTypes.object,
        group: PropTypes.object,
        hide: PropTypes.object,
        item: PropTypes.object,
        logo: PropTypes.object,
        menu: PropTypes.object,
        menuButton: PropTypes.object,
        menuContent: PropTypes.object,
        menuItem: PropTypes.object,
        navPopoverPaper: PropTypes.object,
        noPadding: PropTypes.object,
        root: PropTypes.object,
        title: PropTypes.object,
        titleShift: PropTypes.object,
        toolbar: PropTypes.object,
        ultraSmall: PropTypes.object
    })
}

export default withStyles(Component, styles)
